import { createSafeContext } from '@mantine/core'

export const [TourContextProvider] = createSafeContext<{
  currentStep: string | null
  jumpToStep: (index: number) => void
  nextStep: () => void
  startTour: () => void
  dismissTour: () => void
  isComplete: boolean
  steps: string[]
}>('useTourContext must be used within a TourProvider')
